import styled from 'styled-components';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Box)`
  width: 100%;
  padding: 0px ${themeSpace(7)};
  padding-bottom: 82px;
  display: grid;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('md')} {
    padding: 82px ${themeSpace(10)};
    grid-template-columns: 1fr 2fr;
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: 82px 0;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  ${themeMediaQuery('md')} {
    max-width: 629px;
  }
  .text-pairing-title {
    font-size: calc(${themeSpace(48)} + ${themeSpace(3)});
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      display: none;
    }
    .text-pairing-title {
      text-align: center;
      font-size: ${themeSpace(8)};
      line-height: ${themeSpace(9)};
      margin-bottom: ${themeSpace(4)};
      width: 100%;
    }
  }
`;
